import { useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, imgUrl, errMsg } from "@/lib/api";
import { FieldLabel } from "@/admin/ui";

export const ImageField = ({ value, onChange, label, hint, testid, aspect = "aspect-[1200/630]" }) => {
  const ref = useRef(null);
  const upload = useMutation({
    mutationFn: (file) => {
      const fd = new FormData();
      fd.append("file", file);
      return api.post("/admin/upload", fd).then((r) => r.data.image_url);
    },
    onSuccess: (url) => { onChange(url); toast.success("Imagen subida"); },
    onError: (e) => toast.error(errMsg(e)),
  });
  return (
    <div data-testid={testid}>
      <FieldLabel hint={hint}>{label}</FieldLabel>
      <div className="flex items-center gap-3">
        <div className={`w-36 ${aspect} bg-muted overflow-hidden shrink-0 grid place-items-center border border-border`}>
          {value ? <img src={imgUrl(value)} alt="" className="h-full w-full object-cover" data-testid={`${testid}-preview`} /> : <span className="text-xs text-muted-foreground">Sin imagen</span>}
        </div>
        <div className="flex flex-col gap-2">
          <Button type="button" variant="outline" size="sm" onClick={() => ref.current?.click()} disabled={upload.isPending} data-testid={`${testid}-upload-btn`}>
            {upload.isPending ? <Loader2 className="animate-spin" /> : <ImagePlus />} Subir
          </Button>
          {value && <Button type="button" variant="ghost" size="sm" onClick={() => onChange(null)} data-testid={`${testid}-remove-btn`}>Quitar</Button>}
        </div>
      </div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => e.target.files?.[0] && upload.mutate(e.target.files[0])} data-testid={`${testid}-file-input`} />
    </div>
  );
};
